import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";
import Utilities from '@/Utility/Utilities';
import { RichTextEditor } from 'rad-coreframe-rich-text-editor';

export default class CrfRichTextEditorBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.cfrichtexteditor = {
            init: (node, valueAccessor) => {
                let element = $(node);
                let v = valueAccessor();
                let isReadonly = v.readonly;
                let maxLength = v.maxLength;
                let value = v.value;
                let language = v.language;
                let widget = v.widget;
                let subscriptions = [];
                let interval = null;
                let timeout = null;
                let onAfterInit = v.onAfterInit;

                let clearAll = () => {
                    clearInterval(interval);
                    clearTimeout(timeout);
                }


                let tryToInitEditor = () => {
                    if (document.body.contains(node)) {
                        clearAll();

                        let editor = new RichTextEditor(node, { Value: value(), Language: language(), ReadOnly: isReadonly(), MaxLength: maxLength, onAfterInit: onAfterInit });

                        $(node).on('TextChanged', (ev, newVal) => {
                            value(newVal);
                        });

                        if (value && Utilities.isFunction(value.subscribe)) {
                            subscriptions.push(value.subscribe((newvalue) => {
                                editor.SetValue(newvalue);
                            }));
                        }

                        if (language && Utilities.isFunction(language.subscribe)) {
                            subscriptions.push(language.subscribe((newlang) => {
                                editor.SetLanguage(newlang);
                            }));
                        }

                        if (isReadonly && Utilities.isFunction(isReadonly.subscribe)) {
                            subscriptions.push(isReadonly.subscribe((isReadonly) => {
                                editor.SetReadOnly(isReadonly);
                            }));
                        }


                        widget(editor);
                    }
                }

                interval = setInterval(tryToInitEditor, 300);
                timeout = window.setTimeout(() => {
                    clearAll();
                }, 10000);


                ko.utils.domNodeDisposal.addDisposeCallback(node, () => {
                    for (let i = 0; i < subscriptions.length; i++) {
                        subscriptions[i].dispose();
                        subscriptions[i] = null;
                    }
                    subscriptions = [];

                    clearAll();
                });
            }
        };
    }
}